module.exports = __webpack_public_path__ + "static/img/10033.93cdd8d2.png";